/**
 * Base data for upload mock in the capital decrease modal.
 * Paste here the object with shareClassId, holdingClassName, sharePrice and partners.
 *
 * When pressing "Upload mock" these data are converted into movements, historyMovements
 * and transactions in the modal.
 */
export type BaseDataPartner = {
  partnerId: string;
  partnerName: string;
  rangeFrom: number;
  rangeTo: number;
  sharesToDecrease: number;
};

export type BaseDataForCapitalDecrease = {
  shareClassId: string;
  holdingClassName: string;
  sharePrice: number;
  partners: BaseDataPartner[];
};

export const baseDataForCapitalDecrease: BaseDataForCapitalDecrease = {
  shareClassId: '679ba8c9f1a6a17fac5bb369',
  holdingClassName: 'Clase B',
  sharePrice: 0,
  partners: [
    // Paste here the partners with: partnerId, partnerName, rangeFrom, rangeTo, sharesToDecrease
  ],
};
